export default [
  {
    name: 'uploadImage',
    method: 'POST',
    path: '/vue/image/upload'
  }
];

// 文件上传接口
export const uploadImage = '/vue/image/upload';
